import * as React from 'react';

import './SectionView.scss';

import { RouteComponentProps } from 'react-router';
import SeasonList from 'src/components/Season/SeasonList/SeasonList';
import { connect } from 'react-redux';
import { ApplicationState } from 'src/store';
import { Section } from 'src/store/sections/types';
import { getSection } from 'src/store/sections/actions';
import { NormalizedObjectsString } from 'src/store/shared/types';
import { sectionSelected } from 'src/store/layout/actions';
import LoadingSpinner from 'src/components/utils/LoadingSpinner/LoadinSpinner';

interface RouteProps {
  sectionTitle: string;
}

interface MappedProps {
  section?: Section;
  getSection: typeof getSection;
  loading: boolean;
  sectionSelected: typeof sectionSelected;
}

interface MappedProps {
  sections: NormalizedObjectsString<Section>;
}

type AllProps = MappedProps & RouteComponentProps<RouteProps>;

class SectionView extends React.Component<AllProps> {
  public componentDidMount() {
    const sectionTitle = this.props.match.params.sectionTitle;
    this.props.getSection(sectionTitle);
    this.props.sectionSelected(sectionTitle);
  }

  public render() {
    const { loading } = this.props;
    console.log(this.props.match.params.sectionTitle);
    const section = this.props.sections.byId[this.props.match.params.sectionTitle];
    return (
      <div className="container">
        <LoadingSpinner pending={loading} />
        {section && <SeasonList section={section} />}
      </div>
    );
  }
}
const mapStateToProps = (state: ApplicationState) => ({
  sections: state.sections.data,
  loading: state.sections.loading
});

const mapDispatchToProps = (dispatch: any) => ({
  getSection: (sectionTitle: string) => dispatch(getSection(sectionTitle)),
  sectionSelected: (sectionTitle: string) => dispatch(sectionSelected(sectionTitle))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SectionView);



// WEBPACK FOOTER //
// ./src/pages/SectionView/SectionView.tsx